<template>
  <div class="combobox-processing-item-error-display pointer-events-auto">
    <div
      class="mr-2 rounded-md p-2 text-sm"
      :class="
        modelValue.weight === ExceptionWeights.ERROR
          ? 'bg-error text-on-error'
          : 'bg-warning text-on-warning'
      "
    >
      <div class="font-bold">{{ modelValue.getTitle() }}</div>
      <div>{{ modelValue.getMessage() }}</div>
      <GeneralButton
        v-if="modelValue.weight === ExceptionWeights.WARNING"
        @click="$emit('clearError')"
        class="border-surface my-1 border"
      >
        Melding sluiten
      </GeneralButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import GeneralButton from "@/components/inputs/GeneralButton.vue"
import type { BaseException } from "@/exceptions/base-exception.exception"

const modelValue = defineModel<BaseException>({ required: true })

defineEmits(["clearError"])
</script>

<style scoped></style>
